import { render, staticRenderFns } from "./PageSubLeaveApplicationList.vue?vue&type=template&id=a58db228"
import script from "./PageSubLeaveApplicationList.vue?vue&type=script&lang=js"
export * from "./PageSubLeaveApplicationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports